import { UserStatus } from '@capital-markets-gateway/api-client-identity';
import type { apiTypes } from '@cmg/common';
import type { FC } from 'react';
import { Fragment } from 'react';

import type { User } from '../../../../../../types/domain/user/user';
import { ResendInviteAction } from './ResendInviteAction';
import { UnlockUserAction } from './UnlockUserAction';
import { UpdateStatusAction } from './UpdateStatusAction';

export type Props = Readonly<{
  onReset: () => void;
  isLoading: Readonly<boolean>;
  user: Readonly<User>;
  canCreateOrEditUser: Readonly<boolean>;
  updateUserStatusError: Readonly<apiTypes.GenericServerError | null>;
  onUpdateUserStatus: (userStatus: UserStatus) => void;
  unlockUserError: Readonly<apiTypes.GenericServerError | null>;
  onUnlockUser: () => void;
  resendInviteError: Readonly<apiTypes.GenericServerError | null>;
  onResendInviteEmail: () => void;
}>;

export const UserHighlightsCreateOrEditActions: FC<Props> = ({
  onReset,
  isLoading,
  user,
  canCreateOrEditUser,
  updateUserStatusError,
  onUpdateUserStatus,
  unlockUserError,
  onUnlockUser,
  resendInviteError,
  onResendInviteEmail,
}) => {
  if (!canCreateOrEditUser) {
    return null;
  }

  return (
    <Fragment>
      {!user.accountConfirmed && (
        <ResendInviteAction
          onReset={onReset}
          isLoading={isLoading}
          error={resendInviteError}
          onResendInviteEmail={onResendInviteEmail}
        />
      )}
      {user.isLockedOut && user.status === UserStatus.ACTIVE && (
        <UnlockUserAction
          onReset={onReset}
          isLoading={isLoading}
          error={unlockUserError}
          onUnlockUser={onUnlockUser}
        />
      )}
      <UpdateStatusAction
        onReset={onReset}
        userStatus={user.status}
        isLoading={isLoading}
        error={updateUserStatusError}
        onUpdateUserStatus={onUpdateUserStatus}
      />
    </Fragment>
  );
};
